import FAQ from "components/molecules/common/FAQ"
import { LiveLink, Content, Speakers } from "./Info"

export function EventInfo({
  webinar,
  visibleLink = false,
}: {
  webinar: Webinar
  visibleLink?: boolean
}) {
  return (
    <div className="space-y-6 text-white">
      {visibleLink ? <LiveLink url={webinar.url} /> : null}
      {webinar?.summary && webinar?.summary.length > 0 && (
        <Content className="font-display text-xl">{webinar?.summary}</Content>
      )}
      {webinar?.sections.map((section, id) => <Content>{section}</Content>)}
      {webinar?.speakers?.length > 0 && (
        <Speakers speakers={webinar.speakers} />
      )}
      {webinar?.faqs?.length > 0 ? (
        <FAQ pairs={webinar.faqs} theme="light" key={webinar.time.getTime()} />
      ) : null}
      {webinar?.footer ? <Content>{webinar.footer}</Content> : null}
    </div>
  )
}
